import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/competition-stacking/actions';
import {SimpleSelect} from 'react-selectize';
import UserMessagesDictionary from 'components/organisms/competition-stacking/dictionaries/UserMessagesDictionary';

function prepareCompetitions(opponents) {
    const competitions = {};

    Object.values(opponents).map((player) => {
        const competitionId = player.competitionName;

        if (!competitions.hasOwnProperty(competitionId)) {
            competitions[competitionId] = {
                teamNames: [],
                opponentIds: [],
            };
        }

        competitions[competitionId].teamNames.push(player.team);
        competitions[competitionId].opponentIds.push(player.getId());
    });

    return competitions;
}

function prepareOptions(competitions) {
    return Object.keys(competitions).map((competitionId) => {
        return prepareOption(competitionId, competitions[competitionId].teamNames);
    });
}

function prepareOption(value, teamNames) {
    return value ? {value, label: teamNames.join('@')} : '';
}

class Competition extends Component {
    onChange(selected) {
        let competition = {competitionId: '', opponentIds: []};
        if (selected) {
            competition = {
                competitionId: selected.value,
                opponentIds: this.competitions[selected.value].opponentIds,
            };
        }
        this.props.dispatch(Action.do('setCompetition', this.props.itemId, competition));
    }

    getCompetitionTeamNames(competitionId) {
        if (this.competitions.hasOwnProperty(competitionId)) {
            return this.competitions[competitionId].teamNames;
        }

        return [];
    }

    render() {
        const {stacking, itemId, opponents} = this.props;
        const competitionType = stacking.getCompetitionType();

        if (!opponents.hasPlayers()) {
            return false;
        }

        this.competitions = prepareCompetitions(opponents.all());

        const competitionId = stacking.getItemById(itemId).getCompetitionId();

        return (
            <SimpleSelect
                defaultValue={''}
                options={prepareOptions(this.competitions)}
                placeholder={UserMessagesDictionary.getCompetitionSelectPlaceholder(competitionType)}
                value={prepareOption(competitionId, this.getCompetitionTeamNames(competitionId))}
                onValueChange={(value) => ::this.onChange(value)}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {players},
        competitionStacking,
    } = state;
    return {
        stacking: competitionStacking,
        opponents: players,
    };
}

export default connect(mapStatesToProps)(Competition);
